import { useEffect } from "react";

/**
 * Sets document.title for the lifetime of the component, restoring the
 * previous title on unmount. The app has a single static <title> in
 * public/index.html for every route (WCAG 2.1 SC 2.4.2 requires page titles
 * to describe the page's purpose), so pages needing a distinct title should
 * call this hook.
 */
export function useDocumentTitle(title: string) {
	useEffect(() => {
		const previousTitle = document.title;
		document.title = title;
		return () => {
			document.title = previousTitle;
		};
	}, [title]);
}
